/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { BestOdds, BetHandler, priceButton, pricesProvider } from 'rp-prices-component';
import { RaceDayLive } from 'rp-race-day-live';
import BetslipInteracter from '../utils/BetslipInteracter';

/**
 * Component that is used for rendering <RacedayLive />
 */
class RacedayLive extends PureComponent {
    static propTypes = {
        /**
         * Limit of displayed topics
         * Default value is 4
         */
        maximumTopicsInList: PropTypes.number.isRequired,
        /**
         * adaptForExNarrowLayout
         * Default value is true
         */
        adaptForExNarrowLayout: PropTypes.bool.isRequired,
        /**
         * buttonOnlyAtTop
         * Default value is true
         */
        buttonOnlyAtTop: PropTypes.bool.isRequired,
    };

    static get defaultProps() {
        return {
            maximumTopicsInList: 4,
            adaptForExNarrowLayout: true,
            buttonOnlyAtTop: true,

        };
    }

    componentDidMount() {
        const { maximumTopicsInList, adaptForExNarrowLayout, buttonOnlyAtTop } = this.props;

        (new BestOdds());           // eslint-disable-line no-new
        (new BetHandler());         // eslint-disable-line no-new
        priceButton.activate();

        this.RDL.init({
            maximumTopicsInList,
            adaptForExNarrowLayout,
            buttonOnlyAtTop,
        });

        const betslipInteracter = new BetslipInteracter();
        betslipInteracter.init()
            .then(betslipFeedName => pricesProvider.init(betslipFeedName));
    }

    RDL = new RaceDayLive();

    render() {
        return (
            <div className="rh-racedayLive">
                <div className="rh-racedayLive__title">Raceday live</div>
                <div
                    className="rh-racedayLive__list rdl-content js-diffusionTopicSettingsRace"
                    id="rdl-content"
                />
                <div className="rh-racedayLive__footer">
                    <a
                        href="news/live"
                        className="rh-racedayLive__button ui-btn ui-btn_secondary"
                    >
                        Full live service</a>
                </div>
            </div>
        );
    }
}

export { RacedayLive as default };



// WEBPACK FOOTER //
// ./src/js/RacedayLive/RacedayLive.js